<style lang="scss" src="./index.scss" scoped></style>

<style>
.upcoming_list .upcoming_item .label img {
  height: 25px;
}
</style>

<template>
  <div class="mod_upcoming" v-report.expose="report('',null,true)">
    <div class="mod_hd">
      <div class="mod_title">
        <h2 class="title">
          <span class="txt">{{title}}</span>
          <a  @click="moreMovie" v-report="report('more')">
            <SvgIcons type="arrow_right" v-if="!showIcon" class="icon_right"></SvgIcons>
          </a>
        </h2>
      </div>
    </div>
    <div class="mod_bd">
      <ul class="upcoming_list">
        <li class="upcoming_item" @click="play(item.cid)" v-for="(item,index) in list" :key="index" v-report="report('detail', item)">
          <a class="link">
            <div class="pic_box">
              <img :src="item.pic | filterImage" alt="item.title" class="pic">
            </div>
            <div class="movie_name">{{item.title}}</div>
            <i class="label" v-html="item.imgTagFormat"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import SvgIcons from '@tencent/vft-ui/src/SvgIcons/SvgIcons.vue'
import atom from '@tencent/vft-atom'
import env from '@tencent/vft-common/env'
import { getNewVIPMovie } from '../service'

const VIP_MOVIE = {
  f_module: 'VIP会员新片',
  f_hottag: 'vipnewmovie',
  MORE: {
    f_hottag: 'vipnewmovie_more',
    f_resource: '更多'
  },
  DETAIL: {
    f_hottag: 'vipnewmovie_detail',
    f_resource: 'VIP会员新片'
  }
}

export default {
  props: {
    title: {
      default: 'VIP会员新片',
      type: String
    },
    url: {
      default: '',
      type: String
    },
    showIcon: {
      default: false,
      type: Boolean
    },
    option: {
      type: Object
    }
  },
  async created() {
    this.list = await getNewVIPMovie()
  },
  data() {
    return {
      list: []
    }
  },
  components: {
    SvgIcons
  },
  methods: {
    play(cid) {
      atom.play(cid, this.option)
    },
    report(type, item, isModule = false) {
      let _param = $.extend({}, {}, {
        f_type: isModule ? 1 : 4,
        f_module: VIP_MOVIE.f_module
      });
      if (isModule) {
        _param = $.extend(_param, {
          f_hottag: VIP_MOVIE.f_hottag
        });
        return _param;
      }
      switch (type) {
        case 'more':
          _param = $.extend(_param, VIP_MOVIE.MORE);
          break;
        case 'detail':
          _param = $.extend(_param, {
            f_hottag: `vipnewmovie_${item.cid}`,
            f_resource: item.title,
            f_cid: item.cid
          });
          break;
      }
      return _param;
    },
    moreMovie() {
      if (env.isApp) {
        let url = 'tenvideo2://?action=3&channelId=100120&channelTitle=VIP会员&uiType=6&filter=';
        url += `channel_type${encodeURIComponent('=')}movie
          ${encodeURIComponent('&')}sort${encodeURIComponent('=')}17
          ${encodeURIComponent('&')}iarea${encodeURIComponent('=')}-1
          ${encodeURIComponent('&')}itype${encodeURIComponent('=')}-1
          ${encodeURIComponent('&')}iyear${encodeURIComponent('=')}-1
          ${encodeURIComponent('&')}iattribute${encodeURIComponent('=')}-1
          ${encodeURIComponent('&')}iawards${encodeURIComponent('=')}-1
          ${encodeURIComponent('&')}type{encodeURIComponent('=')}1`;
        atom.openUrl(url);
      } else {
        location.href = 'https://film.qq.com/weixin/all.html';
      }
    }
  },
  filters: {
    filterImage(url) {
      return url.replace(/^http:\/\//, 'https://')
    }
  }
}
</script>
